import axios from 'axios'
const API_URL = process.env.REACT_APP_API_BASE_URL
const PRICING_API_URL = API_URL + '/pricing_service'

export const calculateRates = async (data) => {
  return await axios.post(`${PRICING_API_URL}/calculate_rates`, data)
}

export const estimatePrice = async (data) => {
  return await axios.post(`${PRICING_API_URL}/estimate_price`, data)
}

export const groundFuelSurcharge = async () => {
  return await axios.get(`${API_URL}/fuel_surcharge`)
}
